module.exports = __webpack_public_path__ + "static/media/ki.4e0c4d8f.svg";